import { useState } from 'react';
import SectionHeader from './SectionHeader';

const FAQS = [
  {
    q: '「51擦边审核标准」到底指什么？',
    a: '它不是一个官方名词，而是对平台内容审核中「擦边判定」的口语化概括——即内容既不明显违规、又明显在打规则擦边球时，平台依据哪些尺度、按什么顺序处置。本站把它拆成视觉、话术、行为、语境四个维度来讲。',
  },
  {
    q: '哪种内容最容易被打成「擦边」？',
    a: '综合来看，画面只做「暗示性引导」而不真正越线的内容，命中率最高——比如强指向的封面构图、谐音绕词、评论区往越线方向带节奏。机器初审看单帧，人工复核看整条链路，两者都沾边的风险最大。',
  },
  {
    q: '被判违规，是不是只能直接下架？',
    a: '不是。处置是分档的：提醒、限流、整改、下架、封禁依次加重。多数首次轻微违规落在前几档，整改后能恢复；只有性质严重或屡教不改，才会走到下架甚至账号封禁。',
  },
  {
    q: '被误判下架了，申诉有用吗？',
    a: '有用，但有讲究。申诉时别只喊「我没错」，要针对被点名的维度逐条说明，并主动附上整改后的版本。证据充分的误判回退概率不低；反而是二次整改前先想清楚再发，避免升级成账号维度处罚。',
  },
  {
    q: '把「尺度边界」看这么细，是为了踩线吗？',
    a: '恰恰相反。这个站点整理边界，是为了让你在「不确定会不会被判定」时能提前预判、主动规避——把边界看清楚，才能真守住，而不是反复在边缘试错后被封。',
  },
  {
    q: '看完这些，自己能判断一条内容会不会被封吗？',
    a: '可以做个大致判断：平台处置是动态组合，没有一条绝对公式。你能掌握的是「最容易被点名的几类触发点」和「处置怎么逐级升级」。对吃瓜者，这能让你看懂一条内容为何突然消失；对创作者，这是上架前最后的自查参考。',
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid gap-8 lg:grid-cols-[1fr_1.5fr] lg:gap-14">
          <div className="lg:sticky lg:top-24 lg:self-start">
            <SectionHeader
              eyebrow="审核问答 · FAQ"
              title="大家常问的几个问题"
              desc="围绕审核标准、尺度边界、下架原因与申诉路径，我们把高频疑问集中答一遍，尽量减少「出事再查」的慌乱。"
            />
            <div className="mt-6 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3.5 py-1.5 text-xs font-semibold text-secondary-800">
                <i className="ri-shield-check-line" /> 规则向解读
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3.5 py-1.5 text-xs font-semibold text-accent-800">
                <i className="ri-question-line" /> 高频提问
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3.5 py-1.5 text-xs font-semibold text-primary-700">
                <i className="ri-restart-line" /> 申诉路径
              </span>
            </div>
          </div>

          <div className="space-y-3">
            {FAQS.map((f, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={f.q}
                  className={`overflow-hidden rounded-2xl border transition-colors ${
                    isOpen ? 'border-primary-300 bg-background-100/60' : 'border-background-200 bg-background-50'
                  }`}
                >
                  <button
                    onClick={() => setOpen(isOpen ? null : i)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <h3 className="flex items-start gap-3 font-serif text-base font-bold text-foreground-950 md:text-lg">
                      <span className="mt-0.5 font-black text-primary-400">0{i + 1}</span>
                      {f.q}
                    </h3>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                        isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-700'
                      }`}
                    >
                      <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-lg`} />
                    </span>
                  </button>
                  <div className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 pl-[52px] text-sm leading-relaxed text-foreground-600 md:text-base">
                        {f.a}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}